import React from 'react';
import {Box} from "@mui/material";

import ButtonMailto from "./ButtonMailto";

function EmojiBullet(props) {
    const {emoji, text, type} = props;

    function renderSwitch(text, type) {
       switch(type) {
          case 'text':
          return text;
          case 'mail':
          return <ButtonMailto label={text} mailto={`mailto:${text}`} />;
       }
    }

    return (
        <Box component={'li'} fontSize={'1rem'} lineHeight={1.5} style={{cursor: 'default'}}>
            <Box component={'span'} aria-label="cheese"
                 role="img"
                 mr={{xs: '0.5rem', md: '1rem'}} fontSize={'1.5rem'}>{emoji}</Box>
                 { renderSwitch(text, type) }
        </Box>
    );
}

export default EmojiBullet;
